import React, { FC } from 'react';
import { HomeData } from '../../../../../shared/types';
import { calculateArticleLink, calculateCategoryLink } from '../../../shared/helpers';
import { Image } from '../../../shared/Image';

import './index.scss';

const responsiveImageData = {
  sizes: ['(min-width: 1160px) 300px', '(min-width: 480px) 555px', '432px'],
  srcSet: [300, 600],
};

interface ArticleListProps {
  articles: HomeData['articles'];
}

const ArticleList: FC<ArticleListProps> = ({ articles }) => (
  <div className="articles">
    {articles.map((article, idx) => (
      <div key={idx}>
        <a href={calculateArticleLink(article)} className="media-wrapper">
          <Image
            srcset={[article.mainImage.image]}
            alt={article.mainImage.alt}
            responsiveImageData={responsiveImageData}
            lazyLoad={idx > 5}
          />
        </a>
        <a href={calculateCategoryLink(article.category.value.data)} className="article-category">
          {article.category.value.data.heading}
        </a>
        <a href={calculateArticleLink(article)} className="title">
          <h3>{article.title}</h3>
        </a>
        <h5>{article.description}</h5>
      </div>
    ))}
  </div>
);

export default ArticleList;
